import { render } from "./RetributionTable.vue?vue&type=template&id=1611af1f"
import script from "./RetributionTable.vue?vue&type=script&lang=js"
export * from "./RetributionTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__